/* eslint-disable no-template-curly-in-string */
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { Form, Field, withFormik, getIn } from 'formik';
import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import * as Yup from 'yup';
import ReactGA from 'react-ga';
import { Regex, Masks, industries } from '../../shared/helpers';
import HeroImage from '../Login/dream-it-reel.png';
import { Input as FormInput, Dropdown as FormDropdown } from '../Form';
import {
  withInputClassNames,
  withDropdownClassNames,
} from './../EditProfile/HOC';
import './NewAccount.css';

const Input = withInputClassNames(FormInput);
const Dropdown = withDropdownClassNames(FormDropdown);

const NewAccountForm = ({
  clientTabActive,
  values,
  errors,
  dirty,
  handleBlur,
  handleChange,
  isSubmitting,
  setFieldValue,
  getTrack,
  updateTrack,
  track,
}) => {
  const industryOptions = industries.map(industry => ({
    key: industry,
    text: industry,
    value: industry,
  }));

  const [dirtyForm, changeDirtyHandler] = useState(false);

  useEffect(
    () => {
      if (!get(track, 'id')) {
        getTrack();
      }
    },
    [getTrack, track],
  );

  const handleNotifyFillingEvent = event => {
    handleBlur(event);
    notifyFillingEventField(event);
  };

  const notifyFillingEventField = event => {
    // eslint-disable-next-line no-unused-expressions
    event.persist && event.persist();
    const { name, value, type } = event.target;
    console.log('{ name, value, type }', { name, value, type });
    const error = getIn(errors, name);

    if (error) return;

    sentEvent(name);
    updateTrack({
      track: {
        ...track,
        metadata_attributes: {
          [name]: type !== 'password' ? value : 'Password filled',
        },
      },
    });
  };

  const notifyFillingEventCheckbox = event => {
    event.persist();
    handleChange(event);
    const { name, checked } = event.target;

    if (checked) {
      sentEvent(name);
      updateTrack({
        track: {
          ...track,
          metadata_attributes: {
            [name]: `filled`,
          },
        },
      });
    }
  };

  const sentEvent = name => {
    ReactGA.event({
      category: 'Create Account Field',
      action: `${name} filled`,
    });
  };

  return (
    <div className="container create-profile-body">
      <div className="col col-lg-6 mx-auto">
        <div className="pt-5 mt-2 row text-center">
          <div className="col-12">
            <img alt="logo" className="mb-3" src={HeroImage} />
          </div>
          <div className="col-12">
            <p className="t-15 mb-4 text-gray create-account-header-text">
              {clientTabActive
                ? 'Create your account to begin working on a project!'
                : 'Create your account to join our network of talented professionals!'}
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-lg-7 mx-auto">
          <div className="bg-white shadow-card p-5">
            <Form>
              <div className="form-row">
                <p className="text-darkgreen font-weight-bold t-21 mb-3 mt-3">
                  My Account Info
                </p>
              </div>
              <div className="form-row">
                <div className="col-9 col-md px-0">
                  <div className="row">
                    <div className="col-6 w-100">
                      <Input
                        oldStyle={false}
                        hasInput={!!values.first_name}
                        label="First Name*"
                        name="first_name"
                        onBlur={handleNotifyFillingEvent}
                      />
                    </div>
                    <div className="col-6">
                      <Input
                        name="last_name"
                        label="Last Name*"
                        oldStyle={false}
                        hasInput={!!values.last_name}
                        onBlur={handleNotifyFillingEvent}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <Input
                  label="E-mail*"
                  name="email"
                  type="email"
                  oldStyle={false}
                  hasInput={!!values.email}
                  onBlur={handleNotifyFillingEvent}
                />
              </div>
              <div className="form-row">
                <Input
                  label="Phone Number (optional)"
                  name="phone_number"
                  oldStyle={false}
                  hasInput={!!values.phone_number}
                  onBlur={handleNotifyFillingEvent}
                />
              </div>
              <div className="form-row">
                <div className="col-9 col-md px-0">
                  <div className="row">
                    <div className="col-6 w-100">
                      <Input
                        type="password"
                        label="Password*"
                        name="password"
                        hasInput={!!values.password}
                        oldStyle={false}
                        className="new-account__content-input"
                        onBlur={handleNotifyFillingEvent}
                      />
                    </div>
                    <div className="col-6">
                      <Input
                        type="password"
                        label="Confirm Password*"
                        name="password_confirmation"
                        oldStyle={false}
                        hasInput={!!values.password_confirmation}
                        className="new-account__content-input"
                        onBlur={handleNotifyFillingEvent}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {clientTabActive && (
                <div className="form-row">
                  <div className="col mb-3">
                    <p className="t-13 text-gray-light">
                      Want to learn more about our managed service?
                    </p>
                  </div>
                  <div className="col mb-3">
                    <div className="custom-control custom-checkbox">
                      <Field
                        type="checkbox"
                        name="is_learn_managed_service"
                        id="managed-yes"
                        defaultChecked={values.isLearnManagedService === true}
                        onChange={e => {
                          setFieldValue(
                            'is_learn_managed_service',
                            !values.isLearnManagedService,
                          );
                          notifyFillingEventCheckbox(e);
                        }}
                        className="custom-control-input"
                      />
                      <label
                        className="custom-control-label t-13"
                        htmlFor="managed-yes"
                      >
                        Yes
                      </label>
                    </div>
                  </div>
                </div>
              )}
              <hr />
              <div className="form-row">
                <div className="col">
                  <p className="text-darkgreen font-weight-bold t-21 mb-3 mt-3 additional-details">
                    {clientTabActive ? 'Company Details' : 'Additional Details'}
                  </p>
                </div>
              </div>
              {clientTabActive ? (
                <div className="client-active-tab">
                  <div className="form-row">
                    <div className="col-9 col-md px-0">
                      <div className="row">
                        <div className="col mb-6">
                          <Input
                            label="Company Name (if applicable)"
                            name="company_name"
                            oldStyle={false}
                            hasInput={!!values.company_name}
                            onBlur={handleNotifyFillingEvent}
                            className="new-account__content-input"
                          />
                        </div>
                        <div className="col mb-6">
                          <Dropdown
                            label="Industry"
                            oldStyle={false}
                            hasInput={!!values.industry_type}
                            extraClassName="additional-dropdown"
                            fluid
                            placeholder="Select an Industry"
                            selection
                            name="industry_type"
                            options={industryOptions}
                            onChange={({ value }) => {
                              notifyFillingEventField(
                                { target: { name: 'industry_type', value } },
                                errors,
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="client-notactive-tab">
                  <div className="form-row">
                    <Input
                      label="Portfolio"
                      type="text"
                      name="portfolio_url"
                      className="new-account__content-input"
                    />
                  </div>
                  <div className="form-row">
                    <Input
                      label="Vimeo URL"
                      type="text"
                      name="dribbble_url"
                      className="new-account__content-input"
                    />
                  </div>
                  <div className="form-row">
                    <Input
                      label="Linkedin URL"
                      type="text"
                      name="linkedin_url"
                      className="new-account__content-input"
                    />
                  </div>
                </div>
              )}
              <div className="form-row">
                <div className="col mb-3">
                  <div className="custom-control custom-checkbox">
                    <Field
                      type="checkbox"
                      name="terms_conditions"
                      id="terms_conditions"
                      className="custom-control-input"
                      onChange={notifyFillingEventCheckbox}
                    />
                    <label
                      className="custom-control-label t-13"
                      htmlFor="terms_conditions"
                    >
                      <span className="t-13 text-gray-light">
                        I agree to the {` `}
                        <a
                          href="https://dreamitreel.com/terms-of-service/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms and Conditions
                        </a>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="text-center mt-5">
                <button
                  type="submit"
                  className={`btn ${
                    dirty && isEmpty(errors) && !isSubmitting
                      ? 'btn-primary'
                      : 'btn-outline-dark'
                  }`}
                  disabled={
                    !dirty || !isEmpty(errors) || isSubmitting
                  }
                >
                  Create Account
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

NewAccountForm.propTypes = {
  clientTabActive: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
  track: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  getTrack: PropTypes.func,
  updateTrack: PropTypes.func,
};

const formatSubmit = (onSubmit, values, setSubmitting) => {
  const sanitizedValues = omit(values, 'clientTabActive');
  const formattedValues = {
    type: values.clientTabActive ? 'Client' : 'Freelancer',
    ...sanitizedValues,
  };

  ReactGA.event({
    category: 'User',
    action: 'Account Creation',
  });

  return onSubmit(formattedValues, setSubmitting);
};

export default withFormik({
  handleSubmit: (values, { props, setSubmitting }) => {
    props.updateTrack({
      track: {
        ...props.track,
        done: true,
        metadata_attributes: {},
      },
    });
    return (
      props.onSubmit && formatSubmit(props.onSubmit, values, setSubmitting)
    );
  },
  mapPropsToValues: props => ({
    ...props,
    is_learn_managed_service: true,
  }),
  validateOnChange: true,
  validateOnBlur: true,
  validationSchema: Yup.object().shape({
    first_name: Yup.string()
      .min(2, 'Name should have at least ${min} characters')
      .required('First Name is required'),
    last_name: Yup.string()
      .min(2, 'Name should have at least ${min} characters')
      .required('Last Name is required'),
    email: Yup.string()
      .email('Email is invalid')
      .required('Email is required'),
    phone_number_ddi: Yup.string().required('Phone Number DDI is required'),
    phone_number: Yup.string().required('Phone Number is required'),
    password: Yup.string()
      .min(8, 'Password should have at least ${min} characters')
      .required('Password is required'),
    password_confirmation: Yup.string()
      .min(8, 'Password should have at least ${min} characters')
      .oneOf([Yup.ref('password'), null], 'Passwords are not the same')
      .required('Confirm Password is required'),
    portfolio_url: Yup.string().matches(Regex.site, 'Portfolio url is invalid'),
    dribbble_url: Yup.string().matches(Regex.site, 'Vimeo url is invalid'),
    linkedin_url: Yup.string().matches(Regex.site, 'Linkedin url is invalid'),
    terms_conditions: Yup.bool()
      .required()
      .test('true', "this isn't the number i want", value => value === true),
  }),
  displayName: 'NewAccountForm',
})(NewAccountForm);



// WEBPACK FOOTER //
// ./src/components/NewAccount/NewAccount.js